import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Hoş geldiniz, " + u.full_name);
      if (next && next.startsWith("/") && !next.startsWith("//")) navigate(next);
      else if (u.role === "admin") navigate("/admin");
      else if (u.role === "b2b_dealer") navigate("/bayi-paneli");
      else navigate("/hesabim");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="kz-container py-16 max-w-md">
      <h1 className="font-display text-3xl font-black mb-1">Giriş Yap</h1>
      <p className="text-ink-500 mb-8">{next === "/odeme" ? "Siparişinizi tamamlamak için giriş yapın" : "Hesabınıza erişin"}</p>
      <form onSubmit={submit} className="kz-card p-6 space-y-4">
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">E-posta</span>
          <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Şifre</span>
          <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <button data-testid="login-submit" disabled={loading} className="kz-btn-primary w-full">
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
        <div className="text-sm text-center text-ink-500 pt-2 border-t border-ink-200">
          Üye değil misiniz? <Link data-testid="login-register-link" to={next ? `/kayit?next=${encodeURIComponent(next)}` : "/kayit"} className="text-brand font-semibold hover:underline">Kayıt Ol</Link>
          <br/>Bayi misiniz? <Link to="/bayi-basvuru" className="text-b2b font-semibold hover:underline">Bayi Başvurusu</Link>
        </div>
      </form>
    </div>
  );
}
